import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=09ec9856&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ec9856')) {
      api.createRecord('09ec9856', component.options)
    } else {
      api.reload('09ec9856', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=09ec9856&", function () {
      api.rerender('09ec9856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CkMrdItJoh90/JS/imageCarousel.vue"
export default component.exports